// source https://stackoverflow.com/questions/9514179/how-to-find-the-operating-system-details-using-javascript
const UNKNOWN = "Unknown";

const trimVersion = (version: string): string => {
  const trimIndexes = [";", " ", ")"].map(separator => version.indexOf(separator)).filter(index => index !== -1);
  if (!trimIndexes.length) return version;
  return version.substring(0, Math.min(...trimIndexes));
};

const getBrowserInfo = (userAgent: string) => {
  const browserDetectors = [
    {
      name: "Opera",
      token: "Opera",
      versionOffset: 6,
      versionToken: "Version",
      versionTokenOffset: 8
    },
    { name: "IE", token: "MSIE", versionOffset: 5 },
    { name: "IE", token: "Trident/", versionToken: "rv:", versionTokenOffset: 3 },
    { name: "Chrome", token: "Chrome", versionOffset: 7 },
    {
      name: "Safari",
      token: "Safari",
      versionOffset: 7,
      versionToken: "Version",
      versionTokenOffset: 8,
      overrideNameToken: "CriOS",
      overrideName: "Chrome"
    },
    { name: "Firefox", token: "Firefox", versionOffset: 8 }
  ];

  const detector = browserDetectors.find(item => userAgent.includes(item.token));
  if (!detector) return { browser: UNKNOWN, version: "" };

  const versionToken = detector.versionToken && userAgent.includes(detector.versionToken);
  const offset = versionToken ? detector.versionTokenOffset : detector.versionOffset;
  const token = versionToken ? detector.versionToken : detector.token;
  const browser =
    detector.overrideNameToken && userAgent.includes(detector.overrideNameToken)
      ? detector.overrideName
      : detector.name;

  return {
    browser,
    version: trimVersion(userAgent.substring(userAgent.indexOf(token) + offset))
  };
};

const clientStrings = [
  { s: "Windows 10", r: /(Windows 10.0|Windows NT 10.0)/ },
  { s: "Windows 8.1", r: /(Windows 8.1|Windows NT 6.3)/ },
  { s: "Windows 8", r: /(Windows 8|Windows NT 6.2)/ },
  { s: "Windows 7", r: /(Windows 7|Windows NT 6.1)/ },
  { s: "Windows Vista", r: /Windows NT 6.0/ },
  { s: "Windows Server 2003", r: /Windows NT 5.2/ },
  { s: "Windows XP", r: /(Windows NT 5.1|Windows XP)/ },
  { s: "Windows 2000", r: /(Windows NT 5.0|Windows 2000)/ },
  { s: "Windows ME", r: /(Win 9x 4.90|Windows ME)/ },
  { s: "Windows 98", r: /(Windows 98|Win98)/ },
  { s: "Windows 95", r: /(Windows 95|Win95|Windows_95)/ },
  { s: "Windows NT 4.0", r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/ },
  { s: "Windows CE", r: /Windows CE/ },
  { s: "Windows 3.11", r: /Win16/ },
  { s: "Android", r: /Android/ },
  { s: "Open BSD", r: /OpenBSD/ },
  { s: "Sun OS", r: /SunOS/ },
  { s: "Chrome OS", r: /CrOS/ },
  { s: "Linux", r: /(Linux|X11(?!.*CrOS))/ },
  { s: "iOS", r: /(iPhone|iPad|iPod)/ },
  { s: "Mac OS X", r: /Mac OS X/ },
  { s: "Mac OS", r: /(Mac OS|MacPPC|MacIntel|Mac_PowerPC|Macintosh)/ },
  { s: "QNX", r: /QNX/ },
  { s: "UNIX", r: /UNIX/ },
  { s: "BeOS", r: /BeOS/ },
  { s: "OS/2", r: /OS\/2/ },
  { s: "Search Bot", r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/ }
];

const getOperatingSystem = (userAgent: string): string => clientStrings.find(cs => cs.r.test(userAgent))?.s ?? UNKNOWN;

const getOperatingSystemVersion = (os: string, userAgent: string): { os: string; osVersion: string } => {
  if (/Windows/.test(os)) {
    const windowsVersion = /Windows (.*)/.exec(os);
    return { os: "WinNT", osVersion: windowsVersion?.[1] ?? "0.0" };
  }

  const osVersionMatch = /(?:Android|Mac OS|Mac OS X|MacPPC|MacIntel|Mac_PowerPC|Macintosh) ([._\d]+)/.exec(userAgent);
  if (["Mac OS", "Mac OS X", "Android"].includes(os)) {
    return { os, osVersion: osVersionMatch?.[1] ?? "0.0" };
  }

  if (os === "iOS") {
    const iOSVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(userAgent);
    return { os, osVersion: `${iOSVersion?.[1] ?? 0}.${iOSVersion?.[2] ?? 0}.${iOSVersion?.[3] ?? 0}` };
  }

  return { os, osVersion: "0.0" };
};

export function obterDadosNavigator() {
  const userAgent = navigator.userAgent;
  const browserInfo = getBrowserInfo(userAgent);
  const osInfo = getOperatingSystemVersion(getOperatingSystem(userAgent), userAgent);
  const browser = browserInfo.browser === UNKNOWN && osInfo.os === "iOS" ? "Safari" : browserInfo.browser;
  const version = browserInfo.browser === UNKNOWN && osInfo.os === "iOS" ? osInfo.osVersion : browserInfo.version;

  return {
    browser,
    browserVersion: version,
    os: osInfo.os,
    osVersion: osInfo.osVersion
  };
}
